import React from 'react';
import { Icon, Modal } from 'antd';
import DragAndDrop from './../DragAndDrop';
import i18n from './../../../../../constants/initLng';
import Ripple from './../Ripple';
import ImageViewer from '../ImageViewer';
import {getFilenameFromUrl} from './../../../../../helpers/functions';
import './styles.less';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper'
import ImageItem from './Components/ImageItem';
import { cloneDeep } from 'lodash';
import VideoItem from './Components/VideoItem';

export const TYPE_IMAGE_ENUM = {
    '3x3': '3x3',
    full: 'full'
}
export default class UploadImage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showViewer: false,
            showViewer3x3: false,
            activeShowIndex: 0,
        };
        this.fileInput = React.createRef();
    }

    onSelectFile = () => {
        !this.props.loading && this.fileInput.current && this.fileInput.current.click();
    };

    onDropFile = (files) => {
        if (files && files.length > 0 && this.props.onChange) {
            return this.props.onChange({ target: { files } })
        }
    }

    onChange = (e) => {
        if (this.props.onChange && e.target.files && e.target.files.length) {
            this.props.onChange(e);
        } else if (this.props.onCancel) {
            this.props.onCancel(e)
        }
        // clear selected file
        this.fileInput.current.value = null;
    }

    onClickZoom = ({ index, type }) => (e) => {
        e.stopPropagation();
        if (type === "3x3") {
            this.setState({ showViewer3x3: true, showViewer: true, activeShowIndex: index })
            return;
        }

        this.setState({ showViewer3x3: false, showViewer: true, activeShowIndex: index })
    }
    
    moveImageItem = (dragIndex, hoverIndex) => {
        const thumbnailsClone = cloneDeep(this.props.thumbnails);
        const dragCard = thumbnailsClone[dragIndex];
        const newThumbnails = update(thumbnailsClone, {
        $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
        ],
        });
        this.setState({...this.state, thumbnails: newThumbnails });
        if(this.props.onChangeOrder) {
            this.props.onChangeOrder(newThumbnails);
        }
    }

    render() {
        const thumbnailSize = this.props.thumbnailSize || 120;
        const buttonSize = this.props.buttonSize || 120;
        const { className, style, multiple } = this.props;

        const WrapperComponent = (props) => {
            if(this.props.allowChangeOrder){
                return <div {...props}>{props.children}</div>
            }
            return <DragAndDrop {...props}>{props.children}</DragAndDrop>;
        }
        
        return (
            <WrapperComponent
                className={`hms-upload-image ${className}`} style={style}
                disabled={this.props.disabledUpload || this.props.allowChangeOrder}
                onDrop={this.onDropFile} dropText={i18n.t('placeHolderForm.dropImage')}>
                <div className="image-list">
                    {!(!multiple && this.props.loading) &&
				        <DndProvider backend={HTML5Backend} key={Math.random()} context={window} >
                            {
                                (this.props.thumbnails || []).map((thumb, index) => {
                                    const typeThumb = thumb.split('.')[thumb.split('.').length - 1];
                                    if(['jpeg','jpg','png'].includes(typeThumb)) {
                                        return(
                                            <ImageItem
                                                key={index}
                                                id={index}
                                                thumbnails={this.props.thumbnails}
                                                thumb={thumb}
                                                index={index}
                                                multiple={multiple}
                                                thumbnailSize={thumbnailSize}
                                                moveImageItem={this.moveImageItem}
                                                onRemoveThumbnail={this.props.onRemoveThumbnail}
                                                onSelectFile={this.onSelectFile}
                                                allowChangeOrder={this.props.allowChangeOrder}
                                                />
                                        )
                                    }else{
                                        return(
                                            <VideoItem
                                                key={index}
                                                id={index}
                                                thumbnails={this.props.thumbnails}
                                                thumb={thumb}
                                                index={index}
                                                multiple={multiple}
                                                thumbnailSize={thumbnailSize}
                                                moveVideoItem={this.moveImageItem}
                                                onRemoveThumbnail={this.props.onRemoveThumbnail}
                                                onSelectFile={this.onSelectFile}
                                                allowChangeOrder={this.props.allowChangeOrder}
                                            />
                                        )
                                    }
                                    
                                }
                                // (
                                //     <ImageItem
                                //         key={index}
                                //         id={index}
                                //         thumbnails={this.props.thumbnails}
                                //         thumb={thumb}
                                //         index={index}
                                //         multiple={multiple}
                                //         thumbnailSize={thumbnailSize}
                                //         moveImageItem={this.moveImageItem}
                                //         onRemoveThumbnail={this.props.onRemoveThumbnail}
                                //         onSelectFile={this.onSelectFile}
                                //         allowChangeOrder={this.props.allowChangeOrder}/>
                                // )
                                )
                            }
                        </DndProvider>
                    }

                    {(this.props.multiple || this.props.loading || !this.props.thumbnails || !this.props.thumbnails.length) && !this.props.disabledUpload &&
                        <Ripple className="upload-button" onClick={this.onSelectFile} style={{ width: buttonSize, height: buttonSize }}>
                            <Icon type={this.props.loading ? 'loading' : 'plus'} />
                            <div className="upload-text">{!this.props.loading ? this.props.uploadText : (this.props.loadingText || this.props.uploadText)}</div>
                        </Ripple>
                    }
                </div>
                {/* {this.renderViewer()} */}
                <input ref={this.fileInput} type="file" name={`file`} multiple={this.props.multiple} style={{ display: 'none' }}
                    onChange={this.onChange}
                    accept={this.props.accept}
                    className={`uploadFile`} />
            </WrapperComponent>
        )
    }

    renderViewer() {
        return (this.props.thumbnails && !!this.props.thumbnails.length &&
            <ImageViewer
                isPreview3x3={this.state.showViewer3x3}
                backdropCloseable={true}
                {...(this.props.viewerProps || {})}
                currImg={this.state.activeShowIndex}
                showThumbnails={this.props.thumbnails.length > 1}
                isOpen={this.state.showViewer}
                onClose={() => this.setState({ showViewer: false })}
                onClickPrev={() => this.setState({ activeShowIndex: this.state.activeShowIndex - 1 })}
                onClickNext={() => this.setState({ activeShowIndex: this.state.activeShowIndex + 1 })}
                onClickThumbnail={(i) => this.setState({ activeShowIndex: i })}
                imgs={this.props.thumbnails.map(src => ({src, alt: getFilenameFromUrl(src)}))}
                thumbnails={this.props.thumbnails}
            />
        )
    }

}

UploadImage.defaultProps = {
    removeWithoutConfirm: false,
}
